{
	"backLinkTitle": "Назад към Управление на декларации"
}
